<template>
  <v-container fluid class="edu_level-management mt-4 px-1">
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการระดับการศึกษา</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + edu_levels.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="edu_levels"
                :search="search"
                sort-by="order_seq">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.edu_level_type="{ item }">
                <span>{{ displayText(item.edu_level_type) }}</span>

              </template>

              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3" v-if="state=='editForm'">
                  <v-text-field
                      v-model="editForm.edu_code"
                      :counter="5"
                      :rules="editForm.codeRules"
                      label="รหัสระดับการศึกษา"
                      required
                      disabled
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="3" v-else>
                  <v-text-field
                      v-model="editForm.edu_code"
                      :counter="5"
                      :rules="editForm.codeRules"
                      label="รหัสระดับการศึกษา"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.edu_name_th"
                      :rules="editForm.textReqRules"
                      label="ระดับการศึกษา (TH)"
                      required
                  ></v-text-field>
                </v-col>


              </v-row>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.edu_name_en"
                      :rules="editForm.textReqRules"
                      label="ระดับการศึกษา (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.order_seq"
                      label="ลำดับ"
                      required
                      disabled
                      v-if="state=='addForm'"
                  ></v-text-field>

                  <v-text-field
                      v-model="editForm.order_seq"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="ลำดับ"
                      required
                      v-else
                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="7">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';

export default {
  name: 'EduLevelManagement',
  data() {
    return {
      state: 'index',
      snackbar: null,
      search: '',
      selected: [],
      headers: [
        {
          text: 'รหัสระดับการศึกษา',
          align: 'start',
          value: 'edu_code',
        },
        {text: 'ระดับการศึกษา(TH)', value: 'edu_name_th'},
        {text: 'ระดับการศึกษา(EN)', value: 'edu_name_en'},

        {text: 'ลำดับ', value: 'order_seq'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ["order_seq"],
        sortDesc: [true]
      },

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        edu_code: '',
        codeRules: validateRules.codeRules,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        edu_name_th: '',
        edu_name_en: '',
        order_seq: null,
        active: 'N',
      },
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('edu_levels', ['edu_levels', "isReceiving", "isDeleting", "idToDelete", "edu_levelMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    edu_levelMessage() {

      if (this.edu_levelMessage !== '') {
        this.notification = this.edu_levelMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getEdu_levelsRequest();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('edu_levels',
        [
          "getEdu_levelsRequest",
          "deleteEdu_levelRequest",
          "updateEdu_levelRequest",
          "createEdu_levelRequest"
        ]
    ),
    addItem() {
      this.editedIndex = -1 //index = -1 add

      this.editForm.edu_code = null;
      this.editForm.edu_name_th = null;
      this.editForm.edu_name_en = null;
      this.editForm.order_seq = 'AUTO';
      this.editForm.active = 'Y';
      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.edu_levels.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.edu_code = item.edu_code;
      this.editForm.edu_name_th = item.edu_name_th;
      this.editForm.edu_name_en = item.edu_name_en;
      this.editForm.order_seq = item.order_seq;
      this.editForm.active = item.active;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteEdu_levelRequest({edu_code: item.edu_code})


    },
    close() {

      if (this.errorMessage == false || this.edu_levelMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.edu_levels[this.editedIndex], this.editForm)
            :
            this.updateEdu_levelRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.edu_levels.push(this.editForm)
            :
            this.createEdu_levelRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },

  },
}
</script>

<style src="./EduLevelManagement.scss" lang="scss"/>
